import { Alert, Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { DuplicateSessionModal } from './DuplicateSessionModal';

interface Props {
  reconnect?: () => void;
  title: string;
}

export function DuplicateSession(props: Props) {
  const { title, reconnect } = props;
  const [isModalOpen, setIsModalOpen] = useState(true);

  const onCloseModal = () => setIsModalOpen(false);

  const handleReconnect = () => {
    setIsModalOpen(false);
    reconnect?.();
  };

  return (
    <div className="my-12 flex w-full items-center justify-center">
      {!isModalOpen && (
        <div className="flex gap-4">
          <Alert type="warning">
            {title} is open in another window. Click "Use here" to use {title}{' '}
            in this window.
          </Alert>
          <Button variant="primary" onClick={handleReconnect}>
            Use {title} here
          </Button>
        </div>
      )}
      {isModalOpen && (
        <DuplicateSessionModal
          onCloseCb={onCloseModal}
          reconnect={handleReconnect}
          title={title}
          open
        />
      )}
    </div>
  );
}
